import { HttpService } from '@/infra'

export class RenovarTokenService extends HttpService {
  execute = async () => {
    const response = await this.http.post(`/api/v2/Login/RenovarToken`)
    return response
  }
}
